/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React, { useState, useEffect, Fragment } from 'react';
import { MessageBar, MessageBarType, PrimaryButton, Spinner, SpinnerSize } from '@fluentui/react';
import { TextField, } from '@fluentui/react';
import { AUTH_CONFIG } from './auth0-variables';
import axios from 'axios';
import TwoSidedLayout from '../components/TwoSidedLayout';
import { useHistory, Link } from "react-router-dom";

const error = (e) => css`
    .ms-TextField-fieldGroup {
        border-color: ${e ? '#ff1f1f' : '#D5DBE4'};
    }
    .ms-TextField-errorMessage{
    color:#ff1f1f;
        padding-top: 0;
    }
    `;
function ForgotPassword(props) {
    const [email, setEmail] = useState();
    const [sent, setSent] = useState(false);
    const [loading, setLoading] = useState(false);

    const [emailError, setEmailError] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    const handleSubmit = (i, type, value) => {
        setLoading(true);
        var model = {
            Value: email
        }
        axios.post(AUTH_CONFIG.API_URL + "/api/auth/forgotpassword", model)
            .then((response) => {
                //localStorage.setItem('access_token', response.data.token);
                //localStorage.setItem('expires_at', response.data.expires);
                setSent(true)
            })
            .catch((error) => {
                setLoading(false)
                setErrorMessage(error.response.data)
            });
    }

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
        setEmailError(undefined)
    };
     
    return (
        <TwoSidedLayout width={400}>
            <div className="height100 flexcolumn width100" style={{ maxWidth: '400px', margin: 'auto', height: '80%' }}>
            {errorMessage &&
                <MessageBar messageBarType={MessageBarType.error} className="mb10" isMultiline={true}>{errorMessage}</MessageBar>
            }

            {!sent && <div className=" login-page__form ">
                <h2 className="head-30 mb30" >Forgot your password?</h2>
                <p className="mb35" style={{ color: '#68707b' }}>Enter your account's email address and we'll send you a secure link to reset your password.</p>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <div className="mb10" css={error(emailError)}>
                            <TextField
                                errorMessage={emailError}
                                fullWidth
                                id="email"
                                placeholder="jdoe@company.com"
                                label="Email"
                                value={email}
                                onChange={handleEmailChange}
                                styles={{ fieldGroup: { height: '44px' }, field: { height: '42px' } }}
                            />
                        </div>
                        <div>
                            <PrimaryButton
                                text={!loading ? "Send reset instructions" : <Spinner size={SpinnerSize.small} />}
                                onClick={handleSubmit}
                                disabled={!email}
                                style={{ width: '100%' }}
                                className="mt10 continue" />
                           
                        </div>
                    </div>
                </form>
            </div>
            }
            {sent && <div className=" login-page__form " style={{ width: 380 }}>
                <h2 className="head-30 mb30" style={{ fontSize: 24 }}>Done, instructions sent!</h2>
                <p className="mb35" style={{ lineHeight: '28px', fontSize: 16 }}>Check your email <b>{email}</b> and follow the instructions. If you dont see it in your inbox, check the spam folder.</p>
                <div className="displayflex"><Link className="mr10" to="/login">Log in</Link> or <Link className="ml10" to="/signup">Sign Up</Link></div>
            </div>
                }
            </div>
        </TwoSidedLayout>
    );
}

export default ForgotPassword;